import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';

const BetSummery = () => {

  const [loading, setLoading] = useState(true);
  const [gameData, setGameData] = useState([]);
  const [summary, setSummary] = useState({
    totalWin: 0, totalBet: 0, totalRefund: 0, netProfitLoss: 0, totalCount: 0
  });
  // ✅ NEW: provider summary state
  const [providerSummary, setProviderSummary] = useState([]);
  const [providerSort, setProviderSort] = useState({ key: 'totalBet', direction: 'desc' });

  const [pageCount, setPageCount] = useState(1);
  const [activeRange, setActiveRange] = useState('today');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const currentPage = useRef(1);
  const limit = 50;

  const [gameName, setGameName] = useState('');
  const [provider, setProvider] = useState('');

  const toLocalDateString = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // ✅ Fix stale closure: accept searchGameName & searchProvider as params
  const fetchData = async (start, end, pageOnly = false, searchGameName = gameName, searchProvider = provider) => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiConfig.baseURL}/api/agent/casinoSummery`, {
        params: {
          startDate:  start || undefined,
          endDate:    end || undefined,
          page:       currentPage.current,
          limit,
          skipSummary: pageOnly ? 'true' : 'false',
          gameName:   searchGameName || undefined,
          provider:   searchProvider || undefined
        }
      });

      setGameData(response.data.data || []);

      if (!pageOnly) {
        setSummary({
          totalWin:      response.data.totalWin || 0,
          totalBet:      response.data.totalBet || 0,
          totalRefund:   response.data.totalRefund || 0,
          netProfitLoss: response.data.netProfitLoss || 0,
          totalCount:    response.data.totalCount || 0
        });
        // ✅ NEW: set provider summary
        setProviderSummary(response.data.providerSummary || []);
      }

      setPageCount(response.data.pageCount || 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    currentPage.current = 1;
    fetchData(startDate, endDate, false, gameName, provider);
  };

  // ✅ Fix: pass empty strings directly, no setTimeout needed
  const handleClearSearch = () => {
    setGameName('');
    setProvider('');
    currentPage.current = 1;
    fetchData(startDate, endDate, false, '', '');
  };

  const getDateRange = (range) => {
    const now = new Date();
    const todayStr = toLocalDateString(now);
    if (range === 'today') return { start: todayStr, end: todayStr };
    if (range === 'weekly') {
      const start = new Date(now);
      start.setDate(now.getDate() - 7);
      return { start: toLocalDateString(start), end: todayStr };
    }
    if (range === 'monthly') {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start: toLocalDateString(start), end: todayStr };
    }
    return { start: '', end: '' };
  };

  useEffect(() => {
    const { start, end } = getDateRange('today');
    setStartDate(start);
    setEndDate(end);
    fetchData(start, end);
  }, []);

  const handleRangeClick = (range) => {
    setActiveRange(range);
    if (range === 'custom') return;
    const { start, end } = getDateRange(range);
    setStartDate(start);
    setEndDate(end);
    currentPage.current = 1;
    fetchData(start, end, false, gameName, provider);
  };

  // ✅ Fix: pageOnly = true to skip summary re-fetch on page change
  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    fetchData(startDate, endDate, true, gameName, provider);
  };

  // ✅ NEW: sort provider table client-side
  const sortedProviders = [...providerSummary].sort((a, b) => {
    const dir = providerSort.direction === 'asc' ? 1 : -1;
    if (typeof a[providerSort.key] === 'string') {
      return dir * a[providerSort.key].localeCompare(b[providerSort.key]);
    }
    return dir * (a[providerSort.key] - b[providerSort.key]);
  });

  const handleProviderSort = (key) => {
    setProviderSort(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  const ProviderSortIcon = ({ field }) => {
    if (providerSort.key !== field) return <span style={{ color: '#000' }}> ↕</span>;
    return <span> {providerSort.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day   = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year  = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const mins  = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${mins}`;
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    alert(`${label} copied: ${text}`);
  };

  const sortData = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sorted = [...gameData].sort((a, b) => {
      if (key === "amount") return direction === "asc" ? a.amount - b.amount : b.amount - a.amount;
      return direction === "asc"
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    });
    setGameData(sorted);
    setSortConfig({ key, direction });
  };

  const SortIcon = ({ field }) => {
    if (sortConfig.key !== field) return <span style={{ color: '#000' }}> ↕</span>;
    return <span> {sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  const getTypeStyle = (action, type) => {
    if (action === 'win')   return { color: '#000' };
    if (type === 'refund')  return { color: '#000' };
    if (type === 'reject' || type === 'rollback') return { color: '#000' };
    return { color: '#000' };
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin: 1rem 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0;
    gap: 4px;
    li a { border-radius: 6px; padding: 4px 10px; border: 1px solid #334155; cursor: pointer; color: #000; font-size: 13px; }
    li.active a { background: #f59e0b; border-color: #f59e0b; color: #000; font-weight: 700; }
    li.disabled a { color: #000; cursor: default; }
  `;

  const rangeButtons = ['today', 'weekly', 'monthly', 'custom'];

  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
              <h4 className="mb-0">🎰 Casino Summary</h4>
              <Link to="/exchange-summery" className="btn btn-primary btn-sm">
                Exchange 
              </Link> <Link to="/NineWicket" className="btn btn-primary btn-sm">
                NineWicket
              </Link>
            </div>

            {/* Date Range Buttons */}
            <div className="mb-3 d-flex gap-2 flex-wrap">
              {rangeButtons.map(r => (
                <button key={r}
                  onClick={() => handleRangeClick(r)}
                  style={{
                    padding: '6px 14px', borderRadius: '20px', border: 'none',
                    cursor: 'pointer', fontSize: '13px', fontWeight: '600',
                    background: activeRange === r ? '#f59e0b' : '#fff',
                    color: activeRange === r ? '#000' : '#000'
                  }}>
                  {r.charAt(0).toUpperCase() + r.slice(1)}
                </button>
              ))}
            </div>

            {/* Custom Date */}
            {activeRange === 'custom' && (
              <div className="row mb-3 g-2 align-items-end">
                <div className="col-md-4">
                  <input type="date" value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ background: '#ffffff', color: 'black', border: '1px solid #334155' }} />
                </div>
                <div className="col-auto" style={{ color: 'black' }}>→</div>
                <div className="col-md-4">
                  <input type="date" value={endDate}
                    onChange={e => setEndDate(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ background: '#fff', color: 'black', border: '1px solid #334155' }} />
                </div>
                <div className="col-md-2">
                  <button onClick={() => { currentPage.current = 1; fetchData(startDate, endDate, false, gameName, provider); }}
                    className="btn btn-sm w-100"
                    style={{ background: '#f59e0b', color: '#000', fontWeight: '700' }}>
                    Search
                  </button>
                </div>
              </div>
            )}

            {/* Search Bar */}
            <div className="row mb-3 g-2 align-items-end">
              <div className="col-md-4">
                <label style={{ color: '#000', fontSize: '12px', marginBottom: '4px', display: 'block' }}>Game Name</label>
                <input type="text" value={gameName}
                  onChange={e => setGameName(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g. Sweet Bonanza..."
                  className="form-control form-control-sm"
                  style={{ background: '#fff', color: 'black', border: '1px solid #334155' }} />
              </div>
              <div className="col-md-4">
                <label style={{ color: '#000', fontSize: '12px', marginBottom: '4px', display: 'block' }}>Provider</label>
                <input type="text" value={provider}
                  onChange={e => setProvider(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g. Pragmatic Play..."
                  className="form-control form-control-sm"
                  style={{ background: '#fff', color: 'black', border: '1px solid #334155' }} />
              </div>
              <div className="col-md-2">
                <button onClick={handleSearch} className="btn btn-sm w-100"
                  style={{ background: '#f59e0b', color: '#000', fontWeight: '700' }}>
                  🔍 Search
                </button>
              </div>
              <div className="col-md-2">
                <button onClick={handleClearSearch} className="btn btn-sm w-100"
                  style={{ background: '#fff', color: '#000', border: '1px solid #334155' }}>
                  ✕ Clear
                </button>
              </div>
            </div>

            {/* Active search indicator */}
            {(gameName || provider) && (
              <div className="mb-2" style={{ fontSize: '12px', color: '#000' }}>
                🔍 Filtering by:
                {gameName && <span className="ms-2 badge" style={{ background: '#78350f', color: '#000' }}>Game: {gameName}</span>}
                {provider && <span className="ms-2 badge" style={{ background: '#1e3a5f', color: '#000' }}>Provider: {provider}</span>}
              </div>
            )}
            {/* Summary Cards */}
            <div className="row mb-4 g-3">
              <div className="col-6 col-md-2">
                <div className="card text-center" style={{ background: '#fff', border: '1px solid #334155', borderRadius: '12px' }}>
                  <div className="card-body p-3">
                    <div style={{ color: '#000', fontSize: '12px' }}>Total Records</div>
                    <div style={{ color: 'black', fontSize: '20px', fontWeight: '700' }}>{summary.totalCount}</div>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center" style={{ background: '#fff', border: '1px solid #b45309', borderRadius: '12px' }}>
                  <div className="card-body p-3">
                    <div style={{ color: '#000', fontSize: '12px' }}>Total Bet</div>
                    <div style={{ color: '#000', fontSize: '20px', fontWeight: '700' }}>৳{summary.totalBet?.toLocaleString()}</div>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center" style={{ background: '#fff', border: '1px solid #16a34a', borderRadius: '12px' }}>
                  <div className="card-body p-3">
                    <div style={{ color: '#000', fontSize: '12px' }}>Total Win</div>
                    <div style={{ color: '#000', fontSize: '20px', fontWeight: '700' }}>৳{summary.totalWin?.toLocaleString()}</div>
                  </div>
                </div>
              </div>
         
              <div className="col-12 col-md-4">
                <div className="card text-center" style={{
                  background: summary.netProfitLoss >= 0
                    ? 'linear-gradient(135deg, #fff, #fff)'
                    : 'linear-gradient(135deg, #fff, #fff)',
                  border: `1px solid ${summary.netProfitLoss >= 0 ? '#16a34a' : '#dc2626'}`,
                  borderRadius: '12px'
                }}>
                  <div className="card-body p-3">
                    <div style={{ color: summary.netProfitLoss >= 0 ? '#000' : '#000', fontSize: '12px' }}>
                      Net Profit / Loss
                    </div>
                    <div style={{ color: 'black', fontSize: '22px', fontWeight: '800' }}>
                      {summary.netProfitLoss >= 0 ? '+' : ''}৳{summary.netProfitLoss?.toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ✅ NEW: Provider Summary Table */}
            {sortedProviders.length > 0 && (
              <div className="card mb-4" style={{ background: '#fff', border: '1px solid #fff' }}>
                <div className="card-body p-0">
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid #fff' }}>
                    <h6 className="mb-0" style={{ color: '#000' }}>📊 Provider Breakdown</h6>
                  </div>
                  <div style={{ overflowX: 'auto' }}>
                    <table className="table table-hover mb-0" style={{ color: '#000' }}>
                      <thead style={{ borderBottom: '2px solid #334155' }}>
                        <tr>
                          {[
                            { key: 'provider',      label: 'Provider' },
                            { key: 'totalRounds',   label: 'Rounds' },
                            { key: 'totalBet',      label: 'Total Bet' },
                            { key: 'totalWin',      label: 'Total Win' },
                            { key: 'totalRefund',   label: 'Refund' },
                            { key: 'netProfitLoss', label: 'Net P/L' },
                          ].map(col => (
                            <th key={col.key}
                              onClick={() => handleProviderSort(col.key)}
                              style={{ color: '#000', background: 'white', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                              {col.label} <ProviderSortIcon field={col.key} />
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {sortedProviders.map((p, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #fff' }}>
                            <td style={{ fontWeight: '600', color: '#000' }}>{p.provider}</td>
                            <td style={{ color: '#000' }}>{p.totalRounds?.toLocaleString()}</td>
                            <td style={{ color: '#000' }}>৳{p.totalBet?.toLocaleString()}</td>
                            <td style={{ color: '#000' }}>৳{p.totalWin?.toLocaleString()}</td>
                            <td style={{ color: '#000' }}>৳{p.totalRefund?.toLocaleString()}</td>
                            <td style={{ color: p.netProfitLoss >= 0 ? '#000' : '#000', fontWeight: '700' }}>
                              {p.netProfitLoss >= 0 ? '+' : ''}৳{p.netProfitLoss?.toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}


            {/* Main Data Table */}
            <div className="card" style={{ background: 'white', border: '1px solid #fff' }}>
              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center p-5" style={{ color: '#000' }}>Loading...</div>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <table className="table table-hover mb-0" style={{ color: '#cbd5e1' }}>
                      <thead style={{ borderBottom: '2px solid #334155' }}>
                        <tr>
                          <th style={{ color: '#000', cursor: 'pointer', background: 'white' }}
                            onClick={() => sortData("createdAt")}>
                            Date <SortIcon field="createdAt" />
                          </th>
                          <th style={{ color: '#000', cursor: 'pointer', background: 'white' }}
                            onClick={() => sortData("amount")}>
                            Amount <SortIcon field="amount" />
                          </th>
                          <th style={{ color: '#000', background: 'white' }}>Action</th>
                          <th style={{ color: '#000', background: 'white' }}>Type</th>
                          <th style={{ color: '#000', background: 'white' }}>Game</th>
                          <th style={{ color: '#000', background: 'white' }}>Provider</th>
                          <th style={{ color: '#000', background: 'white' }}>Player ID</th>
                          <th style={{ color: '#000', background: 'white' }}>Session ID</th>
                          <th style={{ color: '#000', background: 'white' }}>Round ID</th>
                          <th style={{ color: '#000', background: 'white' }}>Transaction ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {gameData.length > 0 ? (
                          gameData.map((item, index) => (
                            <tr key={index} style={{ borderBottom: '1px solid #fff' }}>
                              <td style={{ fontSize: '13px', color:'#000' }}>{formatDate(item.createdAt)}</td>
                              <td>
                                <span style={{ ...getTypeStyle(item.action, item.type), fontWeight: '600' }}>
                                  ৳{item.amount?.toFixed(2)}
                                </span>
                              </td>
                              <td>
                                <span style={{
                                  ...getTypeStyle(item.action, item.type),
                                  padding: '2px 8px', borderRadius: '10px',
                                  fontSize: '11px', fontWeight: '600',
                                  background: 'rgba(255,255,255,0.05)'
                                }}>
                                  {item.action}
                                </span>
                              </td>
                              <td style={{ color: '#000000', fontSize: '12px' }}>{item.type}</td>
                              <td style={{ fontSize: '12px', color: '#000' }}>{item.gameName || '—'}</td>
                              <td style={{ fontSize: '12px', color: '#000000', fontWeight: '600' }}>{item.provider || '—'}</td>
                              {[
                                { val: item.player_id,      label: 'Player ID' },
                                { val: item.session_id,     label: 'Session ID' },
                                { val: item.round_id,       label: 'Round ID' },
                                { val: item.transaction_id, label: 'Transaction ID' }
                              ].map(({ val, label }) => (
                                <td key={label} style={{ fontSize: '12px' }}>
                                  <span style={{ color: '#000000' }}>{val?.substring(0, 8)}...</span>
                                  <button
                                    onClick={() => copyToClipboard(val, label)}
                                    style={{
                                      background: 'none', border: 'none',
                                      cursor: 'pointer', marginLeft: '4px', fontSize: '12px'
                                    }}
                                    title={`Copy ${label}`}>
                                    📋
                                  </button>
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            {/* ✅ Fix: colSpan 10 (was 9) */}
                            <td colSpan="10" className="text-center py-5" style={{ color: '#000000' }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            {/* Pagination */}
            <MyPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              marginPagesDisplayed={2}
              forcePage={currentPage.current - 1}
            />

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BetSummery;